<template>
    <div class="flex flex-col items-center justify-center w-full ">
        <component
            ref="clients"
            v-for="(client, index) in clients"
            :key="index"
            :is="client.model"
            :data="client.object"
            v-on:remove="removeClient($event, index)"
        />
        <base-add-button
            title="Ajouter un autre Client / Fournisseur"
            @click="addClientCard"
        />
        <base-primary-button title="Suivant" @click="checkClients" />
    </div>
</template>

<script>
import ClientCard from "./components/ClientCard";
import { mapState } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        ClientCard
    },

    data() {
        return {
            clients: []
        };
    },
    mixins: [scrollToError],
    created() {
        this.clients = this.$store.getters["VotreProject/getClients"];
        this.$store.dispatch("forms/currentStepVotreProject", "Vos Clients");
    },

    methods: {
        addClientCard() {
            if (!this.checkForms()) {
                this.clients.push({
                    model: "client-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        name: "",
                        type: "client",
                        clientOrigin: "",
                        caPercentage: null,
                        paymentDeadline: null,
                        paymentType: []
                    }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.clients.forEach(client => {
                if (!client.createClient()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        },
        addOne() {
            this.step++;
        },
        removeClient(payload, index) {
            this.$store.dispatch("VotreProject/removeClient", payload);
            this.clients.splice(index, 1);
        },
        checkClients() {
            if (!this.checkForms() && this.clientLength >= 1) {
                this.$store.dispatch("VotreProject/SaveClients");
                this.$store.dispatch("forms/completStep", "Vos Clients");
                this.$store.dispatch("forms/subStepComplete", "Votre projet");
                this.$router.push({
                    name: "success_message1",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        }
    },
    computed: {
        ...mapState("VotreProject", {
            clientLength: state => state.clients.length
        })
    }
};
</script>

<style></style>
